import React from 'react';
import { useQuery } from '@apollo/client';
import { CircularProgress, Stack } from '@mui/material';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';

import { calendarApi } from '../../api';
import { EventNotesContent } from './EventNotesContent';
import { EventActivityNotesQuery, EventActivityNotesVariables } from '../../api';

interface Props {
  id: string;
}

export const EventNotes = ({ id }: Props) => {
  const { data, loading, previousData, error } = useQuery<EventActivityNotesQuery, EventActivityNotesVariables>(
    calendarApi.calendarEventNotes,
    {
      variables: {
        input: {
          eventActivityId: id,
        },
      },
    }
  );

  const notes = (data ?? previousData)?.dealActivity?.result?.list ?? [];

  return (
    <RenderWithFallback
      error={error}
      isLoading={loading}
      fallBack={
        <Stack alignItems="center" justifyContent="center" padding="1rem">
          <CircularProgress size={20} />
        </Stack>
      }
    >
      <EventNotesContent eventId={id} loading={loading} apiNotes={notes} />
    </RenderWithFallback>
  );
};
